<template>
  <tr>
    <td style="vertical-align: middle; text-align: center" width="5%">
      <social-icon :type="handleChannelType(channelType)" class="channel-icon" />
    </td>
    <td class="project-title" style="vertical-align: middle">
      <div v-if="keyword.length > 0">
        <span class="text-info">{{ keyword }}</span> <strong>to</strong>
        <span class="text-danger">{{ handle }}</span>
      </div>
      <div v-if="!keyword.length">
        <span class="text-danger">{{ handle }}</span>
      </div>
    </td>
    <td class="project-actions" style="vertical-align: middle">
      <el-button :plain="true" type="danger" size="mini" class="unlink-button" @click="handleUnlink"
        >Unlink</el-button
      >
    </td>
  </tr>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'ChannelToCampaignLinkItem',
  components: {
    SocialIcon,
  },
  props: {
    keyword: {
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      required: true,
    },
    handle: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleUnlink() {
      this.$emit('onUnlink');
    },
    handleChannelType(channelType) {
      return channelType.toLowerCase() === 'data import' ? 'Import' : channelType;
    },
  },
};
</script>

<style scoped>
.channel-icon {
  font-size: 24px;
}
.unlink-button {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// ChannelToCampaignLinkItem.vue?071258b4